import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { AuthComponent, Card, Button, GridForm } from '../components';
import { ResourceActions } from '../actions';
import { fetchTypes, accountConstants, apiRoutes, routes } from '../constants';
import { Promise } from 'es6-promise';
import { http, ResourceMap } from '../utils';

const Toggle = props => props.hide ? null : props.children;

class SetSecurityPage extends AuthComponent {

    constructor(props) {
        super(props);

        this.state = {
            showEntitySearch: false,
            errorMessage: ''
        };

        this.authorized = false;
    }

    userDidAuthorize() {
        this.authorized = true;
        this.querySecurity();
    }

    componentWillReceiveProps(props) {
        if (!this.authorized) {
            super.userDidLoad(props.user);
            return;
        }

        if (props.userSecurity.data.role !== '') {
            this.setState({
                showEntitySearch: true
            });
        }
    }

    querySecurity(params = {}) {
        params = Object.assign({}, {
            userId: this.props.location.query['id'] + ''
        }, params);

        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.GET_SECURITY, params));
    }

    loadEntity(id) {
        var url = apiRoutes['GET_' + this.props.userSecurity.data.role.toUpperCase()];
        return this.search(url + id, {});
    }

    searchEntities(input) {
        if (input === '' && this.props.userSecurity.data.id !== 0) {
            return this.loadEntity(this.props.userSecurity.data.id);
        }
        var url = apiRoutes[this.props.userSecurity.data.role.toUpperCase() + '_SEARCH'];
        return this.searchEntity(url, input);
    }

    search(url, payload) {
        let headers = { headers: Object.assign({}, ResourceMap.instance.defaults.headers) };

        return new Promise((resolve, reject) => {
            http.get(url, payload, headers)
                .success((response) => {
                    if (response.results)
                        resolve(response.results);
                    else
                        resolve([response]);
                })
                .error((response) => {
                    reject(response);
                });
        }).then((items) => {
            return { options: items };
        });
    }

    searchEntity(url, input) {
        var payload = {
            searchText: input,
            searchTextCompare: 'StartsWith',
            pageNumber: 1,
            pageSize: 20
        };

        return this.search(url, payload);
    }

    onRoleSelected(value) {
        this.props.dispatch({
            fetchType: fetchTypes.GET_SECURITY,
            type: accountConstants.userSecurityActions.CHANGE_ROLE,
            role: value.value,
            id: value.value == this.props.userSecurity.data.originalRole ? this.props.userSecurity.data.originalId : 0
        });
        this.setMessage('');
    }

    onEntitySelected(value) {
        var id = this.getValueId(value);

        this.props.dispatch({
            fetchType: fetchTypes.GET_SECURITY,
            type: accountConstants.userSecurityActions.CHANGE_ENTITY,
            id: id,
            name: value.name,
            guid: value.guid
        });

        this.setMessage('');
    }

    getValueId(value) {
        if (value.customerID !== undefined) {
            return value.customerID;
        }
        if (value.distributorID !== undefined) {
            return value.distributorID;
        }
        if (value.oemID !== undefined) {
            return value.oemID;
        }
        return null;
    }

    setSecurity(params = {}) {
        this.setMessage('');
        var valid = this.props.userSecurity.data.id > 0;
        if (!valid) {
            this.setMessage('Please select a valid value to continue.');
            return;
        }
        params = Object.assign({}, this.props.userSecurity.data, params);
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.SET_SECURITY, params));
    }

    setMessage(msg) {
        this.setState({ errorMessage: msg });
    }

    authRender() {
        var roles = [
            { value: 'Customer', label: 'Customer' },
            { value: 'Distributor', label: 'Distributor' },
            { value: 'Oem', label: 'OEM' }
        ];

        return (
            <div className="container" id="set-security">
                <div className="row center-cols">
                    <div className="col-md-8">
                        <Card>
                            <div className="card-title-area">
                                <h3>Account Role</h3>
                            </div>
                            <div className="card-body">
                                <div className="option">
                                    <div className={'component-set-security'}>
                                        <GridForm>
                                            <div className="form-group">
                                                <label className="form-control">Username</label>
                                                <label className="form-control-wide">{this.props.userSecurity.data.userName}</label>
                                            </div>
                                            <div className="form-group">
                                                <label className="form-control">Role</label>
                                                <div className="form-control select-container">
                                                    <Select
                                                        name="role-select"
                                                        clearable={false}
                                                        options={roles}
                                                        onChange={val => this.onRoleSelected(val)}
                                                        value={this.props.userSecurity.data.role} />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="form-control">{this.props.userSecurity.data.role}</label>
                                                <div className="form-control select-container">

                                                    <Toggle hide={this.props.userSecurity.data.role !== 'Distributor'}>
                                                        <Select.Async
                                                            valueKey="guid"
                                                            labelKey="name"
                                                            clearable={false}
                                                            value={this.props.userSecurity.data}
                                                            onChange={val => this.onEntitySelected(val)}
                                                            loadOptions={val => this.searchEntities(val)}
                                                            className="form-control" />
                                                    </Toggle>

                                                    <Toggle hide={this.props.userSecurity.data.role !== 'Customer'}>
                                                        <Select.Async
                                                            valueKey="guid"
                                                            labelKey="name"
                                                            clearable={false}
                                                            value={this.props.userSecurity.data}
                                                            onChange={val => this.onEntitySelected(val)}
                                                            loadOptions={val => this.searchEntities(val)}
                                                            className="form-control" />
                                                    </Toggle>

                                                    <Toggle hide={this.props.userSecurity.data.role !== 'Oem'}>
                                                        <Select.Async
                                                            valueKey="guid"
                                                            labelKey="name"
                                                            clearable={false}
                                                            value={this.props.userSecurity.data}
                                                            onChange={val => this.onEntitySelected(val)}
                                                            loadOptions={val => this.searchEntities(val)}
                                                            className="form-control" />
                                                    </Toggle>

                                                </div>
                                            </div>
                                        </GridForm>
                                        <div className="form-error">{this.state.errorMessage}</div>
                                        <div className="form-footer">
                                            <Button className="primary" onClick={() => this.setSecurity()}>Save</Button>
                                            <Button to={routes.USER_MANAGEMENT}>Cancel</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    return {
        appState: state.appState.currentRoute,
        user: state.activeUser,
        userSecurity: state.userSecurity
    }
}

export default connect(select)(SetSecurityPage);


// WEBPACK FOOTER //
// ./web-app/containers/set-security.jsx